import { Box, Typography } from '@mui/material'
import { Info } from '@mui/icons-material'

export const NotSendAllDocumentsWarning: React.FC = () => {

  return (
    <Box sx={{
      gap: 3,
      padding: 3,
      display: 'flex',
      borderRadius: '12px',
      alignItems: 'center',
      flexDirection: 'row',
      border: '1px solid #F3CC04'
    }}>
      <Info fontSize='large' color='primary' />
      <Typography>
        O contrato não pode gerar documentos porque existem dados do cliente que ainda precisam ser informados
      </Typography>
    </Box>
  )
}
